import { buildSeatLayoutSnapshot } from "./venueLayout";

export const isMissingVenueTable = (error) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "").toLowerCase();
  return (
    code === "42P01" ||
    code === "PGRST205" ||
    message.includes("does not exist") ||
    message.includes("could not find the table")
  );
};

export const isMissingVenueColumn = (error) => {
  if (isMissingPolicyColumn(error)) return false;
  const code = String(error?.code || "");
  const message = String(error?.message || "").toLowerCase();
  return (
    message.includes("venue_id") ||
    message.includes("seat_layout_snapshot") ||
    (code === "42703" && (message.includes("venue") || message.includes("snapshot")))
  );
};

export const isMissingPolicyColumn = (error) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "").toLowerCase();
  return (
    message.includes("policy_html") ||
    message.includes("venue_policy_snapshot") ||
    (code === "42703" && message.includes("policy"))
  );
};

export const fetchVenuePolicyHtml = async (client, venueId) => {
  if (!venueId) return null;

  const { data, error } = await client
    .from("venues")
    .select("policy_html")
    .eq("id", venueId)
    .maybeSingle();

  if (error) {
    if (isMissingVenueTable(error) || isMissingPolicyColumn(error)) return null;
    throw error;
  }

  return data?.policy_html || null;
};

export const fetchActiveVenues = async (client) => {
  const { data, error } = await client
    .from("venues")
    .select("id, name, address, seat_plan_image_url, is_archived")
    .eq("is_archived", false)
    .order("name", { ascending: true });

  if (error) {
    if (isMissingVenueTable(error)) return [];
    throw error;
  }

  return data || [];
};

export const fetchVenueWithLayout = async (client, venueId) => {
  if (!venueId) return null;

  const { data: venue, error: venueError } = await client
    .from("venues")
    .select("*")
    .eq("id", venueId)
    .maybeSingle();

  if (venueError) throw venueError;
  if (!venue) return null;

  const { data: sections, error: sectionError } = await client
    .from("venue_sections")
    .select("*")
    .eq("venue_id", venueId)
    .order("sort_order", { ascending: true });

  if (sectionError) throw sectionError;

  const sectionRows = sections || [];
  const sectionIds = sectionRows.map((section) => section.id);
  let seats = [];

  if (sectionIds.length) {
    const { data: seatRows, error: seatError } = await client
      .from("venue_seats")
      .select("*")
      .in("section_id", sectionIds);

    if (seatError) throw seatError;
    seats = seatRows || [];
  }

  return { venue, sections: sectionRows, seats };
};

export const fetchVenueSectionColors = async (client, venueIds = []) => {
  const ids = [...new Set((venueIds || []).filter(Boolean))];
  if (!ids.length) return [];

  const { data, error } = await client
    .from("venue_sections")
    .select("venue_id, name, parent_section_id, color")
    .in("venue_id", ids);

  if (error) return [];
  return data || [];
};

export const buildSnapshotForVenueId = async (client, venueId, sectionColors = {}) => {
  const layout = await fetchVenueWithLayout(client, venueId);
  if (!layout) return null;
  return buildSeatLayoutSnapshot({ ...layout, sectionColors });
};
